import { render, staticRenderFns } from "./RevisarCotizacion.vue?vue&type=template&id=108eb610&lang=pug"
import script from "./RevisarCotizacion.vue?vue&type=script&lang=js"
export * from "./RevisarCotizacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports